import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faTrash, faUserPlus } from '@fortawesome/pro-solid-svg-icons'
import type { BulkProcessAction } from './mutations/bulkProcessApplications'

const descriptors: Record<
  BulkProcessAction,
  { label: string; icon: IconDefinition; description: string }
> = {
  decline: {
    label: 'Rejeter',
    icon: faTrash,
    description:
      'Les candidatures seront marquées comme traitées. Celles liées à une offre seront également archivées.'
  },
  integrate: {
    label: 'Intégrer sans associer',
    icon: faUserPlus,
    description:
      "Les nouveaux candidats seront intégrés dans votre base. Pas d'association aux commandes."
  },
  integrate_accept: {
    label: 'Intégrer et associer',
    icon: faCheck,
    description:
      'Les nouveaux candidats seront intégrés dans votre base. Les candidats seront associés aux commandes (liées aux offres).'
  }
}

export const bulkProcessActionOrder: BulkProcessAction[] = [
  'decline',
  'integrate',
  'integrate_accept'
]

export const bulkProcessActionDescriptor = (action: BulkProcessAction) =>
  descriptors[action]
